// extracted by mini-css-extract-plugin
export var optionGrid = "_8v-7";
export var optionList = "_8v-6";
export var questionsBlock = "_8v-9";
export var spacer = "_8v-5";
export var stepCenteredContent = "_8v-3";
export var stepInner = "_8v-0";
export var stepInnerFullWidth = "_8v-1";
export var stepInnerLockScroll = "_8v-2";
export var stepTransitionFrame = "_8v-4";
export var welcomeBlock = "_8v-8";